"use client";

export interface SectionTitlteProps {
  title: string;
  subtitle?: string;
  className?: string;
}

export function SectionTitlte({
  title,
  subtitle,
  className = "",
}: SectionTitlteProps) {
  return (
    <div className="flex flex-col items-start gap-12 lg:gap-24 text-left justify-center w-full">
      <h2
        className={`text-3xl md:text-5xl font-bold font-switzer text-accent text-left ${className}`}
      >
        {title}
      </h2>
      <p
        className={`text-base font-switzer text-accent/75 text-left ${className}`}
      >
        {subtitle}
      </p>
    </div>
  );
}
